<!DOCTYPE html>
<html lang="en">

<head>
    <meta charset="UTF-8" />
    <title>404 - Not Found</title>
    <meta name="viewport" content="width=device-width, initial-scale=1.0" />
    <style>
        * {
            margin: 0;
            padding: 0;
            box-sizing: border-box;
        }

        body {
            background-image: url('./assets/img/Final-Login-JBN – 2 1.jpg');
            background-position: top;
            background-repeat: no-repeat;
            background-size: cover;

            display: flex;
            background-position: top left, bottom right;
            align-items: center;
            height: 100vh;
            text-align: center;
            flex-direction: column;
            color: #333;
            overflow: hidden;
        }

        .gradient-text {
            font-size: 10rem;
            font-weight: 500;
            background: linear-gradient(90deg, #d51781, #892565);
            -webkit-background-clip: text;
            -webkit-text-fill-color: transparent;
            background-clip: text;
            animation: float 3s ease-in-out infinite, fadeIn 1.5s ease;
            margin-top: 60px;
            text-shadow: 0 6px 1px rgba(0, 0, 0, 0.0980392), 0 0 5px rgba(0, 0, 0, 0.0980392), 0 1px 3px rgb(208 24 127), 0 3px 5px rgb(141 36 102), 0 5px 10px rgba(0, 0, 0, 0.247059), 0 10px 10px rgba(0, 0, 0, 0.2), 0 20px 20px rgba(0, 0, 0, 0.14902);
            margin: 0;
            line-height: normal;
        }

        .message {
            font-size: 1.2rem;
            animation: fadeInUp 2s ease-out;
            color: #00667f;
            font-weight: 700;
            text-align: center;
        }


        .btn-back {
            margin-top: 30px;
            padding: 12px 30px;
            background: none;
            color: #d51781;
            border: 2px solid;
            border-image: linear-gradient(90deg, #d51781, #892565) 1;
            text-decoration: none;
            border-radius: 5px;
            font-weight: bold;
            font-size: 14px;
            transition: all 0.3s ease;
            animation: fadeInUp 2.5s ease-out;
            cursor: pointer;
        }

        .btn-back:hover {
            background: linear-gradient(90deg, #d51781, #892565);
            color: white;
            box-shadow: 0 0 10px #d51781;
        }

        @keyframes fadeIn {
            from {
                opacity: 0;
                transform: scale(0.9);
            }

            to {
                opacity: 1;
                transform: scale(1);
            }
        }

        @keyframes fadeInUp {
            from {
                opacity: 0;
                transform: translateY(20px);
            }

            to {
                opacity: 1;
                transform: translateY(0);
            }
        }

        @keyframes float {
            0% {
                transform: translateY(0);
            }

            50% {
                transform: translateY(-10px);
            }

            100% {
                transform: translateY(0);
            }
        }

        @media screen and (max-width: 1200px) {

            body {
                height: 100vh;
                background-position: top center, bottom center;
            }

            .gradient-text {
                margin-top: 0px;
            }
        }
    </style>
</head>

<body>

    <div class="gradient-text">404</div>
    <div class="message">Oops! Something went wrong.....</div>
    <a class="btn-back" (click)="goBack()">Go To Home Page</a>
    <!-- <div class="gradient-text">4<img src="/assets/img/404.png" height="100" width="100">4</div>
    <div class="message">Sorry, the page you’re looking for doesn’t exist.</div>
    <a class="btn-back" (click)="goBack()">Go Back Home</a> -->
</body>

</html>